﻿import type { AvailabilityAuditReportComponentProps } from './AvailabilityAuditReportComponent';

export const AvailabilityAuditReportComponent = {
    MountAsync: async (target: HTMLElement, props: AvailabilityAuditReportComponentProps) => {
        const { mountReactComponentAsync } = await import('@/utils/mountReactComponentAsync');
        const { AvailabilityAuditReportComponent } = await import('./AvailabilityAuditReportComponent');
        return await mountReactComponentAsync(target, AvailabilityAuditReportComponent, props);
    }
};


